
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcNotificationMessageItem as ObcNotificationMessageItemElement} from '@oicl/openbridge-webcomponents/dist/components/notification-message-item/notification-message-item.js';
 
 
 

 
 export const ObcNotificationMessageItem = createComponent({
   react: React,
   tagName: 'obc-notification-message-item',
   elementClass: ObcNotificationMessageItemElement,
   events: {
     
   }
  });
 
 